export const CIRCLES = {
  TITLE: 'Circles',
  ARIA: {
    CREATE: 'Create circle',
    MANAGE: 'Manage circle',
    DELETE: 'Delete circle',
    TABS: 'Circle details',
    REMOVE_MEMBER: 'Remove member',
    REMOVE_INPUT: 'Remove input',
  },
  LOADING: 'Loading circles...',
  EMPTY_STATE: 'No circles yet. Create one to share stories with a group.',
  CARD: {
    TAB_MEMBERS: 'Members',
    TAB_STORIES: 'Shared Stories',
    STORIES_LOADING: 'Loading stories...',
    STORIES_EMPTY: 'No stories shared yet.',
    MEMBERS_EXPAND: 'members (expand to view)',
  },
  MODAL: {
    CREATE_TITLE: 'Create Circle',
    MANAGE_TITLE: 'Manage Circle',
    NAME_LABEL: 'Circle name',
    NAME_PLACEHOLDER: 'e.g. Book Club, Tech Writers',
    MEMBERS_LABEL: 'Members',
    ADD_MEMBERS_LABEL: 'Add members',
    CURRENT_MEMBERS: 'Current members',
    REMOVING: 'Removing',
    FROM_FILE: 'members from file',
    CLEAR_FILE: 'Clear and enter manually',
    USERNAME_PLACEHOLDER: '@username',
    UNDO: 'undo',
    ADD_MEMBER: 'Add member',
    ADD_MEMBER_MAX: ' (max reached)',
    UPLOAD_MD: 'Upload .md',
    UPLOAD_CSV: 'Upload .csv',
    HINT_MD: 'each username on a new line',
    HINT_CSV: 'comma separated usernames',
  },
  ERRORS: {
    NO_VALID_USERNAMES: 'No valid usernames found in the file.',
    NAME_REQUIRED: 'Circle name is required.',
    NAME_MAX_LENGTH: 'Circle name must be 90 characters or less.',
    MEMBER_REQUIRED: 'At least one member is required.',
    FAILED_CREATE: 'Failed to create circle.',
    FAILED_UPDATE: 'Failed to update circle.',
    FAILED_DELETE: 'Failed to delete circle:',
  },
  BUTTONS: {
    CANCEL: 'Cancel',
    CREATE: 'Create Circle',
    SAVE: 'Save Changes',
  },
};
